import { authAPI } from 'api/authAPI';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { CANUSER_SCHEMA } from './canUser-Schema';

export const useCanUser = (feature) => {
  const { loading, authenticated } = useSelector((state) => state.users);

  const { data: data_UserGroups, isFetching: isFetching_UserGroups } = useQuery('userGroups', authAPI.getUserAccess, {
    enabled: !loading && authenticated,
    onError: (e) => {
      console.log('error get permissions:', e);
    },
  });

  if (isFetching_UserGroups) {
    return undefined;
  }

  const userLdapGroup = data_UserGroups?.data?.ldapgroup || [];
  const useFeature = feature || '';

  if (!useFeature || !CANUSER_SCHEMA[useFeature]) {
    console.log('CanUser: Invalid feature or schema not found');
    return false;
  }

  const { groups = [] } = CANUSER_SCHEMA[useFeature];

  const isGroupAllowed = userLdapGroup.some((group) => groups.includes(group));

  return isGroupAllowed;
};
